import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost, apiDelete } from "../lib/api";
import { useAuth } from "../context/AuthProvider";

type Props = { userId: string; username?: string; size?: "sm" | "md" };

export default function FollowButton({ userId, username, size = "sm" }: Props) {
  const { user: me } = useAuth();
  const navigate = useNavigate();
  const [following, setFollowing] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);

  const myId = (me as any)?.id ?? (me as any)?._id ?? null;
  const hidden = !myId || String(myId) === String(userId);

  useEffect(() => {
    if (hidden) return;
    let alive = true;
    setFollowing(null);
    (async () => {
      try {
        const res = await apiGet<{ ok: true; following: boolean }>(`/api/follow/is/${userId}`);
        if (alive) setFollowing(res.following);
      } catch {
        if (alive) setFollowing(false);
      }
    })();
    return () => { alive = false; };
  }, [userId, hidden]);

  async function toggle() {
    if (!me) {
      navigate('/login');
      return;
    }
    if (hidden || busy || following === null) return;
    setBusy(true);
    try {
      if (following) {
        await apiDelete(`/api/follow/${userId}`);
        setFollowing(false);
      } else {
        await apiPost(`/api/follow/${userId}`, {});
        setFollowing(true);
      }
    } catch (err) {
      console.error("Takip işlemi hatası:", err);
    } finally {
      setBusy(false);
    }
  }

  if (hidden) return null;

  const label = following === null ? "..." : following ? "Takibi bırak" : "Takip et";
  const pad = size === "sm" ? "4px 8px" : "6px 10px";
  const fs = size === "sm" ? 12 : 14;

  return (
    <button
      disabled={busy || following === null}
      onClick={toggle}
      title={username ? `${username} ${label}` : label}
      aria-label={label}
      aria-pressed={!!following}
      style={{
        marginLeft: 8,
        padding: pad,
        fontSize: fs,
        borderRadius: 8,
        border: "2px solid #114232",
        background: "#114232",
        color: "#fff",
        opacity: busy ? 0.6 : 1,
        cursor: busy || following === null ? "default" : "pointer",
        whiteSpace: "nowrap",
        transition: "all 0.2s ease",
        fontWeight: 600,
      }}
    >
      {label}
    </button>
  );
}
